var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12C14.3682 12 14.6667 12.2984 14.6667 12.6666C14.6667 13.0348 14.3682 13.3333 14 13.3333H4.66671C4.29852 13.3333 4.00004 13.0348 4.00004 12.6666C4.00004 12.2984 4.29852 12 4.66671 12H14ZM14 7.33329C14.3682 7.33329 14.6667 7.63177 14.6667 7.99996C14.6667 8.36815 14.3682 8.66663 14 8.66663H4.66671C4.29852 8.66663 4.00004 8.36815 4.00004 7.99996C4.00004 7.63177 4.29852 7.33329 4.66671 7.33329H14ZM14 2.66663C14.3682 2.66663 14.6667 2.9651 14.6667 3.33329C14.6667 3.70148 14.3682 3.99996 14 3.99996H4.66671C4.29852 3.99996 4.00004 3.70148 4.00004 3.33329C4.00004 2.9651 4.29852 2.66663 4.66671 2.66663H14ZM1.33337 2.66663H2.66671V3.99996H1.33337V2.66663ZM1.33337 7.33329H2.66671V8.66663H1.33337V7.33329ZM1.33337 12H2.66671V13.3333H1.33337V12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.f5a3b6c809cfdf3c30fbadd089d54c27.svg";
export { ForwardRef as ReactComponent };